import _ from 'lodash'

// 获取field
export function getFieldId (props: { fieldid: any; fieldidPrefix: any }) {
  const { fieldid, fieldidPrefix } = props;
  return fieldid || fieldidPrefix;
}

export const getJsonObj = (str: string, val: any) => {
  if (typeof str !== 'string') {
    return val || {};
  }
  let obj = {};
  try {
    obj = JSON.parse(str);
  } catch {
    obj = val || {};
  }
  return obj;
};

export const getObjField = (obj: any, childField: string, field: string, fieldVal: string) => {
  if (obj[childField]) {
    let node,list = [...obj[childField]]
    while(node = list.shift()){
      if (node[field] === fieldVal) {
        return node
      }
      node[childField] && list.push(...node[childField])
    }
  }
};

// 数组去重
// export const removeRepeat = (arr: any, key: string | number) => {
//   const result = [];
//   const obj:any = {};
//   for (const x of arr) {
//     if (!obj[x[key]]) {
//       obj[x[key]] = x;
//       result.push(x);
//     }
//   }
//   return result;
// }

export function awaitTo<T, U = Error> (
  promise: Promise<T>,
  error?: any,
  props?: any
): Promise<[any, U | any]> {
  // !props.rowStore && props?.startLoading?.(); 
  return promise.then<[any, null]>((data: any) => {
    // 成功
    // !props.rowStore && props?.endLoading?.();
    return [data, null];
  }).catch<[undefined, U]>((err: any) => {
    // !props.rowStore && props?.endLoading?.();
    console.log('awaitTo-err--->', err);
    err && props?.message?.danger(`${error?.errMsg || err?.message}`);
    if (error) {
      const parsedError = Object.assign({}, err, error);
      return [undefined, parsedError];
    }
    return [undefined, err];
  });
}

// 计算单个tag所占宽度
export const computedTagWidth = (text: any) => {
  let measureSpan: any = document.getElementById('ynf-mul-tag-span');
  if (measureSpan) {
    measureSpan.innerHTML = text;
  } else {
    const noVisibleSpan = document.createElement('span');
    document.body.appendChild(noVisibleSpan);
    noVisibleSpan.innerHTML = text;
    noVisibleSpan.setAttribute('id', `ynf-mul-tag-span`);
    noVisibleSpan.setAttribute('class', `ynf-mul-tag-span`);
    noVisibleSpan.style.visibility = 'hidden';
    noVisibleSpan.style.position = 'fixed';
    noVisibleSpan.style.fontSize = '12px'
    measureSpan = document.getElementById('ynf-mul-tag-span');
  }
  return measureSpan.getBoundingClientRect().width + 37;
}

// 处理参照condition
export const referFilters = {
  buildCondition: (rootStore: any, opt: any) => {
    const { filterConditions, conditionIsNull, treetableFilter = 'TreeTable' } = rootStore.referInputProps
    const { requestData, exactQuery, stopShow } = rootStore.referStore
    const { cTpltype, extendFieldJson } = rootStore.refEntity
    // const flag = treetableFilter === cTpltype ? true : (treetableFilter === 'TreeTable' || cTpltype === 'TreeTable')
    let condition: any = opt.params?.filterCondition; // 查询条件
    delete opt.params?.filterCondition
    if (exactQuery && requestData.likeValue && !condition) { // 精准搜索
      condition = referFilters.getExactQuery(rootStore.refEntity.cCheckFlds, requestData.likeValue)
    }
    if (extendFieldJson.isShowDisabled) { // 显示停用
      condition = referFilters.getStopStatus(condition, stopShow, extendFieldJson.isShowDisabledData)
    }

    const cloneCondition = _.cloneDeep(condition)
    if (cTpltype === 'TreeTable') {
      if (filterConditions) {
        condition = referFilters.handleFilterParams(filterConditions, conditionIsNull, condition, rootStore);
      }

      if (treetableFilter === 'TreeTable') {
        condition = { treeData: { condition }, condition }
      } else if (treetableFilter === 'Tree') {
        condition = { treeData: { condition } }
      } else { // 这里默认表
        condition = { treeData: { condition: undefined }, condition }
      }

      if (opt.type !== 'init' && treetableFilter === 'Tree') {
        condition = { treeData: { condition: undefined }, condition: cloneCondition }
      }

      return condition
    } else { // tree,table
      if (filterConditions && (treetableFilter === cTpltype || treetableFilter === 'TreeTable')) {
        condition = referFilters.handleFilterParams(filterConditions, conditionIsNull, condition, rootStore);
      }
    }

    return { condition }
  },

  handleFilterParams: (filterConditions: any, conditionIsNull: any, condition: any, referContext: any) => {
    let conditions;
    if (Array.isArray(filterConditions)) {
      // 兼容旧数据
      conditions = referFilters.getFilterConditions(filterConditions, referContext);
      if (conditionIsNull) {
        // 无值不过滤
        conditions = conditions.filter((item: any) => item.value1 !== '' && item.value1 !== undefined && item.value1 !== null);
      }
    } else {
      if (filterConditions.children) {
        conditions = [referFilters.getConditions(filterConditions, referContext)]
      } else {
        conditions = []
      }
    }
    if (condition && condition.simpleVOs) condition.simpleVOs.push(...conditions);
    else condition = { isExtend: true, simpleVOs: [...conditions] };
    return condition;
  },

  // 参照过滤(旧协议)
  getFilterConditions: (filterConditions: any[], referContext: any) => {
    return filterConditions.map((item: { conditionType: number; conditionValueType: string; conditionValue: string; conditionKey: any; compareLogic: any; }) => {
      // 0:公式表达式 1:字段 2:常量
      if (item.conditionType === 2) {
        // 常量
        let v = '';
        if (item.conditionValueType === 'Object') {
          // 参照值, 对象
          v = JSON.parse(item.conditionValue)[0][
            referContext.cEntityKeyFld
          ];
        } else {
          // 参照以外其他的值
          v = item.conditionValue;
        }
        return { field: item.conditionKey, op: item.compareLogic, value1: v };
      } else if (item.conditionType === 1) {
        // 字段
        const _modelpath = item.conditionValue.split(',');
        const storeField = _modelpath[_modelpath.length - 1] || '';
        const temObj: any = referContext.referInputProps.pageStore.rootStore || {};
        let _value1 = '';
        if (temObj.storeType === 'FilterStore') {
          _value1 = temObj[_modelpath[0]]?.getFilterItemByName(storeField).getQueryValue().v1;
        } else {
          _value1 = temObj[_modelpath[0]]?.getValue(storeField);
        }
        return {
          field: item.conditionKey,
          op: item.compareLogic,
          value1: _value1
        };
      }
    });
  },

  // 递归遍历参照过滤
  getConditions: (obj: any, referContext: any) => {
    let logicOp = '';
    let conditions: any = obj.children.map((item: any, index: any) => {
      if (item.isLeaf === false) {
        return referFilters.getConditions(item, referContext);
      }
      logicOp = item.relationType;
      // 0:公式表达式 1:字段 2:常量
      if (item.conditionType === 2) {
        // 常量
        let v = '';
        if (item.conditionValueType === 'Object') {
          // 参照值, 对象
          let vobj: any = {};
          try {
            vobj = JSON.parse(item.conditionValue);
          } catch {
            vobj = item.conditionValue;
          }
          if (Array.isArray(vobj)) {
            v = vobj[0][referContext.cEntityKeyFld];
          } else {
            v = vobj[referContext.cEntityKeyFld];
          }
        } else {
          // 参照以外其他的值
          v = item.conditionValue;
        }
        return { field: item.conditionKey, op: item.compareLogic, value1: v };
      } else if (item.conditionType === 1) {
        // 字段 格式为 'mobx://rootStore.formStore,orgId'
        let storePath = item.conditionValue.replace('mobx://rootStore.', '');
        const storeField = storePath.split(',')[1];
        storePath = storePath.split(',')[0];
        const storePathArr = storePath.split('.');
        let temObj = referContext.referInputProps.pageStore.rootStore || {};
        storePathArr.map((item: string | number) => {
          temObj = temObj[item];
        });
        let _value1 = '';
        if (temObj.storeType === 'FilterStore') {
          _value1 = temObj?.getFilterItemByName(storeField).getQueryValue().v1;
        } else if (temObj.storeType === 'TableStore') {
          const filed = temObj.getColumn(storeField)?.getField();
          const rowStore = referContext.referInputProps.rowStore;
          _value1 = rowStore ? rowStore.getTrueValue(filed) : temObj.getRowByKey(temObj.currentActiveRowKey)
        } else {
          _value1 = temObj?.getValue(storeField);
        }
        return {
          field: item.conditionKey,
          op: item.compareLogic,
          value1: _value1
        };
      }
    });
    const { conditionIsNull } = referContext.referInputProps;
    if (conditionIsNull) {
      // 无值不过滤
      conditions = conditions.filter(
        (item: { value1: string | null | undefined; }) =>
          item.value1 !== '' &&
          item.value1 !== undefined &&
          item.value1 !== null
      );
    }
    if (!logicOp && obj.logicMap) {
      if (obj.logicMap === '&&') {
        logicOp = 'and';
      } else if (obj.logicMap === '||') {
        logicOp = 'or';
      }
    }
    return {
      logicOp,
      conditions
    };
  },

  // 精准搜索
  getExactQuery: (cCheckFlds: string, searchKey: any) => {
    const arr = cCheckFlds.split(',');
    const conditions = arr.map((item) => {
      return { field: item, op: 'eq', value1: searchKey };
    });
    return { isExtend: true, simpleVOs: [{ logicOp: 'or', conditions }] };
  },

  // 显示停用
  getStopStatus: (condition: any, stopStatus: any, isShowDisabledData: any) => {
    const { field = 'stopstatus', op = 'in', disabled = 1, enabled = 0 } = isShowDisabledData
    if (condition && condition.simpleVOs) {
      condition.simpleVOs.push({
        field,
        op,
        value1: stopStatus ? [disabled, enabled] : [enabled]
      });
    } else {
      condition = {
        isExtend: true,
        isRefreshData: true,
        simpleVOs: [
          { field, op, value1: stopStatus ? [disabled, enabled] : [enabled] }
        ]
      };
    }
    return condition;
  }
};

// 判断数组的包含关系
export const arraysContain = (allArr: any, currArr: any) => {
  if (allArr.length < currArr.length || allArr.length === 0) {
    return false
  }
  return currArr.filter((element: any) => allArr.includes(element)).length === currArr.length;
};

// 获取树节点下级某个值
export const getNodeChildren = (node: any, keyField = 'id') => {
  return node?.children.reduce((acc: any, current: any) => {
    if (current[keyField] !== undefined) {
      acc.push(current[keyField]);
    }
    if (Array.isArray(current.children)) {
      acc = acc.concat(getNodeChildren(current));
    }
    return acc;
  }, []) || [];
}

// 转换url
export const paraseUrl = (obj: any) => {
  const res = []
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      res.push(`${key}=${obj[key]}`)
    }
  }
  return res.join('&')
}

export const getPopupContainer = (props: any) => {
  if (props.getPopupContainerDom) {
    return typeof props.getPopupContainerDom === 'function' ? props.getPopupContainerDom() : props.getPopupContainerDom
  } else {
    if (!props.cardBillno) return null // 暂时兼容多个modal弹出层级问题
    const id = props.pageStore?.params?.diworkCode || props.pageStore?.params?.serviceCode || 'root'
    return document.getElementById(id) || document.body
  }
}
